import { forwardRef, Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AbstractFilterValuesLoadGuard } from 'app/core/guards/abstract-filter-values-load.guard';
import { FlowsSandbox } from 'app/core/sandboxes/flows.sandbox';
import { RootState } from '../store';

@Injectable({ providedIn: 'root' })
export class FlowFilterValuesLoadGuard extends AbstractFilterValuesLoadGuard {
  private sandbox: FlowsSandbox;

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => FlowsSandbox)) sandbox) {
    super('FlowFilterValuesLoadGuard', store, (state: RootState) => state.flows.filterValues);
    this.sandbox = sandbox;
  }

  loader(t: any, params: { [p: string]: string }): void {
    this.sandbox.loadFlowsFilterValues();
  }

  resetter(params: { [p: string]: string }): void {
    this.sandbox.resetFlowsFilterValues();
  }

  getDependencyRouteData() {
    return {
      authorization: 'FLOW.QUERY',
    };
  }
}
